import type {Entry, FieldlessEntry} from '$types/contentful';
import type {EntryType} from '$types/entities';
import type {ContentTypeId} from '$lib/enums/entities';

function isContentType(contentType: ContentTypeId) {
  return (entry: EntryType): boolean => {
    return entry.sys.contentType.sys.id === contentType;
  };
}

function hasSysId(id: string) {
  return (entry: EntryType): boolean => {
    return entry.sys.id === id;
  };
}

function hasFields<T>(entity: T | FieldlessEntry | undefined): entity is T {
  return Boolean(entity) && typeof entity['fields'] !== 'undefined';
}

function sortByField(field: string, ascending = true) {
  return (entityA: EntryType, entityB: EntryType): number => {
    const result = entityA.fields[field] > entityB.fields[field] ? 1 : -1;

    return ascending ? result : result * -1;
  };
}

export {isContentType, hasSysId, sortByField, hasFields};
